// extracted by mini-css-extract-plugin
module.exports = {"confirmModal":"styles_confirmModal__2a27r","modalButtons":"styles_modalButtons__1Dz3a"};